import $ from 'jquery';

// --------------------------------------------------
// Image lightbox
// Dependency-free lightbox for the Images page-builder component. Builds
// one shared overlay, groups triggers by their data-lightbox-group, and
// handles open / prev / next / close, keyboard (Esc, ArrowLeft/Right), an
// image counter, optional caption, focus trap + return-focus, and the
// modal scroll-lock class. Single images open without nav; galleries
// cycle within their group.
// --------------------------------------------------

const HTML_VISIBLE = 'html--modal-visible';
const VISIBLE = 'lightbox--visible';

$(function () {
  const $triggers = $('[data-lightbox]');

  if (!$triggers.length) {
    return;
  }

  const $html = $('html');

  const $lightbox = $(
    `<div class="lightbox" role="dialog" aria-modal="true" aria-label="Image viewer">
      <button type="button" class="lightbox__close" aria-label="Close (Esc)">
        <i class="fa-solid fa-xmark" aria-hidden="true"></i>
      </button>
      <button type="button" class="lightbox__nav lightbox__nav--prev" aria-label="Previous image">
        <i class="fa-solid fa-chevron-left" aria-hidden="true"></i>
      </button>
      <figure class="lightbox__figure">
        <img class="lightbox__image" src="" alt="" />
        <figcaption class="lightbox__caption"></figcaption>
      </figure>
      <button type="button" class="lightbox__nav lightbox__nav--next" aria-label="Next image">
        <i class="fa-solid fa-chevron-right" aria-hidden="true"></i>
      </button>
      <p class="lightbox__counter"><span class="lightbox__current">1</span> / <span class="lightbox__total">1</span></p>
    </div>`
  );

  $('body').append($lightbox);

  const $image = $lightbox.find('.lightbox__image');
  const $caption = $lightbox.find('.lightbox__caption');
  const $current = $lightbox.find('.lightbox__current');
  const $total = $lightbox.find('.lightbox__total');
  const $close = $lightbox.find('.lightbox__close');
  const $prev = $lightbox.find('.lightbox__nav--prev');
  const $next = $lightbox.find('.lightbox__nav--next');
  const $counter = $lightbox.find('.lightbox__counter');

  let group = [];
  let index = 0;
  let lastFocus = null;

  function render() {
    const item = group[index];

    if (!item) {
      return;
    }

    $image.attr('src', item.href).attr('alt', item.alt);
    $caption.text(item.caption).toggle(Boolean(item.caption));
    $current.text(index + 1);
    $total.text(group.length);

    const isGallery = group.length > 1;
    $prev.toggle(isGallery);
    $next.toggle(isGallery);
    $counter.toggle(isGallery);
  }

  function open(groupId, startHref) {
    group = $(`[data-lightbox][data-lightbox-group="${groupId}"]`)
      .map((i, el) => {
        const $el = $(el);
        return {
          href: $el.attr('href'),
          caption: $el.attr('data-caption') || '',
          alt: $el.find('img').attr('alt') || ''
        };
      })
      .get();

    index = group.findIndex((item) => item.href === startHref);

    if (index < 0) {
      index = 0;
    }

    render();
    $html.addClass(HTML_VISIBLE);
    $lightbox.addClass(VISIBLE);
    $close.trigger('focus');
  }

  function close() {
    $html.removeClass(HTML_VISIBLE);
    $lightbox.removeClass(VISIBLE);

    if (lastFocus) {
      lastFocus.trigger('focus');
    }
  }

  function step(direction) {
    if (group.length < 2) {
      return;
    }

    index = (index + direction + group.length) % group.length;
    render();
  }

  $triggers.on('click', function (event) {
    event.preventDefault();
    lastFocus = $(this);
    open($(this).attr('data-lightbox-group'), $(this).attr('href'));
  });

  $prev.on('click', () => step(-1));
  $next.on('click', () => step(1));
  $close.on('click', close);

  // Click the backdrop (but not the figure or controls) to close.
  $lightbox.on('click', (event) => {
    if (event.target === $lightbox[0] || event.target === $lightbox.find('.lightbox__figure')[0]) {
      close();
    }
  });

  $(document).on('keydown', (event) => {
    if (!$lightbox.hasClass(VISIBLE)) {
      return;
    }

    switch (event.key) {
      case 'Escape':
        close();
        break;
      case 'ArrowLeft':
        step(-1);
        break;
      case 'ArrowRight':
        step(1);
        break;
      case 'Tab': {
        // Trap focus among the visible controls.
        const $focusable = $lightbox
          .find('.lightbox__close, .lightbox__nav:visible')
          .filter(':visible');
        const first = $focusable.first()[0];
        const last = $focusable.last()[0];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
        break;
      }
      default:
        break;
    }
  });
});
